<!-- =========================================================================================
  File Name: User List View.vue
  Description: Data List - Thumb View
  ----------------------------------------------------------------------------------------
========================================================================================== -->

<template>
  <div id="mes-utilisateurs" class="data-list-container">
    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />

    <vs-table ref="table" v-model="selected" pagination :max-items="itemsPerPage" search :data="comptes">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center">
          <!-- ACTION - DROPDOWN -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
            <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32">
              <span class="mr-2">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Imprimer</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Exporter </span>
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <!-- ADD NEW -->
          <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary bg-primary" @click="addNewData">
            <feather-icon icon=" " svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-white">Nouveau Compte</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ comptes.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : comptes.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th>Photo</vs-th>
        <vs-th sort-key="nom">Nom Complet</vs-th>

        <vs-th sort-key="telephone">Téléphone</vs-th>

        <vs-th sort-key="date_creation">Date de Création</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <!-- <vs-td class="img-container">
                        <img :src="image" class="product-img" />
                    </vs-td> -->

            <vs-td>
              <vs-avatar :src="image" size="30px" class="border-2 border-white border-solid -m-1"></vs-avatar>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.nom + " " + tr.prenom }}</p>
            </vs-td>

            <vs-td>
              <p class="product-category ml-6">{{ tr.telephone }}</p>
              <!-- <vs-progress :percent="Number(tr.popularity)" :color="getPopularityColor(Number(tr.popularity))" class="shadow-md" /> -->
            </vs-td>

            <vs-td>
              <p class="product-price">{{ tr.dateCreation.substring(0, 10) }}</p>
            </vs-td>

            <vs-td class="flex justify-center">
              <!-- <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" /> -->
              <!-- <img key="onlineImg1" :src="imgUpdate" alt="user-img" width="18" height="18" class="  ml-2      " /> -->

              <div class="vx-row">
                <vx-tooltip text="supprimer compte">
                  <img key="onlineImg" text="supprimer compte" :src="imgRemove" alt="user-img" width="18" class="ml-3 flex-1" height="18" @click.stop="deleteData(tr.id)" />
                </vx-tooltip>

                <vx-tooltip text="désactiver compte">
                  <img key="onlineImg3" :src="imgDeasct" alt="user-img" width="18" height="18" class="ml-3 flex-1" @click.stop="desactiverCompte(tr)" v-if="tr.compte.etat == true" />
                </vx-tooltip>
                <vx-tooltip text="activer compte">
                  <img key="onlineImg4" :src="imgActiv" alt="user-img" width="18" height="18" class="ml-3 flex-1" @click.stop="ActiverCompte(tr)" v-if="tr.compte.etat == false" />
                </vx-tooltip>
                <vx-tooltip text="modifier mot de passe">
                  <img key="onlineImg2" id="imgup" :src="imgpwd" alt="user-img" width="18" height="18" class="ml-3 flex-1" @click.stop="updatePassword(tr)" />
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import DataViewSidebar from "./modals/DataViewSidebar.vue";
import moduleDataList from "@/store/data-list/moduleDataList.js";
import jwtService from "@/http/requests/auth/jwt/index.js";
export default {
  components: {
    DataViewSidebar,
  },
  data() {
    return {
      etat: false,
      selected: [],
      comptes: [],
      itemsPerPage: 10,
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {},
      image: require("@/assets/images/portrait/small/user7.png"),
      imgRemove: require("@/assets/images/portrait/small/trash-2.svg"),
      imgUpdate: require("@/assets/images/portrait/small/update2.png"),
      imgpwd: require("@/assets/images/file-icons/password.png"),
      imgDeasct: require("@/assets/images/portrait/small/remove.png"),
      imgActiv: require("@/assets/images/file-icons/padlock.png"),
    };
  },
  watch: {
    comptes: function (val) {
      if (val.length >= 0) {
        this.$vs.loading.close("#mes-utilisateurs > .con-vs-loading");
      }
    },
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },

    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.comptes.length;
    },
  },
  methods: {
    ActiverCompte(tr) {
      this.selected = tr;
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: `Activer Compte`,
        text: "Voulez vous activer le compte de " + tr.nom + " " + tr.prenom,
        acceptText: "Activer",
        cancelText: "Annuler",
        accept: this.onActiverCompte,
      });
    },
    onActiverCompte() {
      let compte = {
        username: this.selected.compte.username,
        etat: true,
        role: "Admin",
      };
      jwtService.desactiverCompte(compte).then(
        (data) => {
          this.$vs.dialog({
            type: "confirm",
            color: "warning",
            title: `Activation Compte`,
            text: "La compte de " + this.selected.nom + " " + this.selected.prenom + "est : ' " + data.data + " '",
          });
          this.selected.compte.etat = true;
          const index = this.dataList.findIndex((p) => p.id == compte.id);
          this.comptes[index] = this.selected;
        },
        (err) => {
          this.$swal.fire({
            position: "absolute",
            icon: "warning",
            title: "Erreur : " + err.response.data,
            showConfirmButton: true,
            timer: 2500,
          });
        }
      );
    },
    updatePassword(tr) {
      this.selected = tr;
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: `Modifier mot de passe `,
        text: "Voulez vous modifier le Mot de passe de " + tr.nom + tr.prenom,
        acceptText: "modifier",
        cancelText: "Annuler",
        accept: this.onUpdatePassword,
      });
    },
    onUpdatePassword() {
      jwtService.updatePassword(this.selected.compte.username).then(
        (data) => {
          this.$vs.dialog({
            type: "confirm",
            color: "warning",
            title: `Nouveau mot de passe`,
            text: "la nouvelle psd de  " + this.selected.nom + this.selected.prenom + "est : ' " + data.data + " '",
          });
        },
        (err) => {
          this.$swal.fire({
            position: "absolute",
            icon: "warning",
            title: "Erreur : " + err,
            showConfirmButton: true,
            timer: 2500,
          });
        }
      );
    },
    desactiverCompteUser() {
      let comte = {
        username: this.selected.compte.username,
        etat: false,
      };
      jwtService.desactiverCompte(comte).then(
        (data) => {
          this.selected.compte.etat = false;
          const index = this.comptes.findIndex((p) => p.id == comte.id);
          this.comptes[index] = this.selected;
          this.$swal.fire({
            position: "absolute",
            icon: "warning",
            title: data.data,
            showConfirmButton: true,
            timer: 2500,
          });
        },
        (err) => {
          this.$swal.fire({
            position: "absolute",
            icon: "warning",
            title: "Error" + err.response.data,
            showConfirmButton: true,
            timer: 2500,
          });
        }
      );
    },
    desactiverCompte(compte) {
      this.selected = compte;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Désactiver Compte `,
        text: "Voulez vous désactiver le compte " + compte.nom + " " + compte.prenom + " de utilisateurs de portail. La désactivation de compte empêche cet utilisateur d'acceder au portail.",
        acceptText: "Désactiver",
        cancelText: "Annuler",
        cancelColor: "#0000",
        accept: this.desactiverCompteUser,
      });
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    deleteData(id) {
      this.$swal
        .fire({
          title: "Êtes-vous sûr ?",
          text: "Vous ne pourrez pas revenir en arrière!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#28C76F",
          cancelButtonColor: "#d33",
          confirmButtonText: "Oui, supprime le !",
        })
        .then((result) => {
          if (result.value) {
            this.$swal.fire({
              position: "absolute",
              icon: "success",
              title: "Le compte a été supprimé.",
              showConfirmButton: false,
              timer: 1500,
            }),
              this.$store.dispatch("dataList/removeComptes", id).catch(() => {
                this.$swal.fire({
                  position: "absolute",
                  icon: "warning",
                  title: "erreur inconnu",
                  showConfirmButton: false,
                  timer: 1500,
                });
              });
          }
        });
    },
    editData(data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    getOrderStatusColor(status) {
      if (status == "on_hold") return "warning";
      if (status == "delivered") return "success";
      if (status == "canceled") return "danger";
      return "primary";
    },
    getPopularityColor(num) {
      if (num > 90) return "success";
      if (num > 70) return "primary";
      if (num >= 50) return "warning";
      if (num < 50) return "danger";
      return "primary";
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
  },
  created() {
    if (!moduleDataList.isRegistered) {
      this.$store.registerModule("dataList", moduleDataList);
      moduleDataList.isRegistered = true;
    }
    // this.$store.dispatch("dataList/fetchDataListComptes")
    if (this.$store.state.AppActiveUser.id != "0") {
      this.$store.dispatch("dataList/fetchDataListComptes").then(() => {
        this.comptes = this.$store.state.dataList.comptes;
      });
    }
    this.$store.subscribe((mutation) => {
      if (mutation.type === "UPDATE_USER_INFO")
        this.$store.dispatch("dataList/fetchDataListComptes").then(() => {
          this.comptes = this.$store.state.dataList.comptes;
          console.log(this.comptes);
        });
    });
  },

  mounted() {
    this.isMounted = true;
    this.$vs.loading({
      background: this.backgroundLoading,
      // color: this.colorLoading,
      type: "radius",
      container: "#mes-utilisateurs",
      scale: 0.45,
      clickEffect: true,
    });
  },
};
</script>

<style lang="scss">
#mes-utilisateurs {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000000;

  .vs-table {
    border-collapse: separate;
    // border-spacing: 0 1.3rem;
    padding: 0 1rem;

    tr {
      box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.05);

      td {
        align-items: center;
        justify-content: center;
        text-align: center;
        vertical-align: middle;

        &:first-child {
          border-top-left-radius: 0.5rem;
          border-bottom-left-radius: 0.5rem;
        }

        &:last-child {
          border-top-right-radius: 0.5rem;
          border-bottom-right-radius: 0.5rem;
        }

        &.img-container {
          span {
            display: flex;
            justify-content: flex-start;
          }

          .product-img {
            height: 110px;
          }
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 5;
        padding-bottom: 5;
        color: "primary";
        background: #002b5c;
        justify-content: center;

        .vs-table-text {
          //text-transform: uppercase;
          font-weight: 600;
          color: white;
          justify-content: center;
        }
      }
    }
  }

  @media (max-width: 461px) {
    .items-per-page-handler {
      display: none;
    }
  }

  @media (max-width: 341px) {
    .data-list-btn-container {
      width: 100%;

      .dd-actions,
      .btn-add-new {
        width: 100%;
        margin-right: 0 !important;
      }
    }
  }

  .product-name {
    max-width: 23rem;
  }

  .vs-table--header {
    display: flex;
    flex-wrap: wrap;
    margin-left: 1.5rem;
    margin-right: 1.5rem;

    > span {
      display: flex;
      flex-grow: 1;
    }

    .vs-table--search {
      padding-top: 0;

      .vs-table--search-input {
        padding: 0.9rem 2.5rem;
        font-size: 1rem;

        & + i {
          left: 1rem;
        }

        &:focus + i {
          left: 1rem;
        }
      }
    }
  }
}
</style>
